import React, { Component } from 'react';
import PropTypes from "prop-types";
import { MyIcon } from "../../common/baseConfig";
import { Input } from "antd";
const TextArea = Input.TextArea;
export default class Questions extends Component {
  static propTypes = {
    body: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  };

  render() {
    let { body, type, data } = this.props;

    if (type === "单选题") {
      body = JSON.parse(body);
      let children = [];
      for (const key in body) {
        if (body.hasOwnProperty(key)) {
          const element = body[key];
          children.push({ select: key, title: element });
        }
      }
      return (
        <div className="center-questions-single">
          <h1>
            <span>【{type}】</span>
            <span dangerouslySetInnerHTML={{ __html: data.Title }} />
          </h1>
          <div className="answer">
            {
              children.map(item => (
                <div className="answer-item" key={item.select}>
                  <p>
                    <MyIcon type={item.select === data.MyAnswer ? "iconxuanzhong" : "iconweixuan"}
                      style={{ color: item.select === data.MyAnswer ? "#ff9900" : "" }}
                    />
                    {
                      item.select === data.Answer && <img className="selectImg" src={require("../../images/select.png")} alt="" />
                    }
                  </p>
                  <p>
                    <span>{item.select}.</span><span dangerouslySetInnerHTML={{ __html: item.title }} />
                  </p>
                </div>
              ))
            }
          </div>
        </div>
      )
    } else if (type === "多选题") {
      body = JSON.parse(body);
      let children = [];
      for (const key in body) {
        if (body.hasOwnProperty(key)) {
          const element = body[key];
          children.push({ select: key, title: element });
        }
      }
      return (
        <div className="center-questions-multiple">
          <h1>
            <span>【{type}】</span>
            <span dangerouslySetInnerHTML={{ __html: data.Title }} />
          </h1>
          <div className="answer">
            {
              children.map(item => (
                <div className="answer-item" key={item.select}>
                  <p>
                    <MyIcon type={data.MyAnswer && data.MyAnswer.indexOf(item.select) !== -1 ? "iconduoxuankuangxuanzhong" : "iconduoxuankuang"}
                      style={{ color: data.MyAnswer && data.MyAnswer.indexOf(item.select) !== -1 ? "#ff9900" : "" }}
                    />
                    {
                      data.Answer.indexOf(item.select) !== -1 && <img className="selectImg" src={require("../../images/select.png")} alt="" />
                    }
                  </p>
                  <p>
                    <span>{item.select}.</span><span dangerouslySetInnerHTML={{ __html: item.title }} />
                  </p>
                </div>
              ))
            }
          </div>
        </div>
      )
    } else if (type === "判断题") {
      //判断题
      let children = [{ select: "1", title: "√" }, { select: "0", title: "×" }]
      return (
        <div className="center-questions-true-false">
          <h1>
            <span>【{type}】</span>
            <span dangerouslySetInnerHTML={{ __html: data.Title }} />
          </h1>
          <ul>
            {
              children.map((it, key) => {
                return (
                  <li className="forbid" key={key} >
                    {
                      data.Answer === it.select && <img className="selectImg" src={require("../../images/select.png")} alt="" />
                    }
                    <MyIcon type={data.MyAnswer === it.select ? "iconxuanzhong" : "iconweixuan"} className={data.MyAnswer === it.select ? "radio-active" : "radio"} />
                    <p>
                      <span>
                        {it.select === "1" ? "A" : "B"}.
                      </span>
                      <span style={{ marginLeft: 5 }} dangerouslySetInnerHTML={{ __html: it.title }} />
                    </p>
                  </li>
                )
              })
            }
          </ul>
        </div>
      )
    } else if (type === "问答题") {
      return (
        <div className="center-questions-essay">
          <h1>
            <span>【{type}】</span>
            <span dangerouslySetInnerHTML={{ __html: data.Title }} />
          </h1>
          <TextArea
            disabled={true}
            value={data.MyAnswer}
            placeholder="请在此处作答"
            className="txtArea"
          />
        </div>
      )
    } else if (type === "填空题") {
      return (
        <div className="center-questions-fills-up">
          <h1>
            <span>【{type}】</span>
            <span>{data.Title}</span>
          </h1>
          <div className="btn">
            <Input
              disabled={true}
              value={data.MyAnswer}
              placeholder="请在此处填上答案"
              className="fillsUp"
            />
          </div>
        </div>
      )
    } else {
      return null;
    }

  }
}



// WEBPACK FOOTER //
// ./src/features/center/Questions.js